import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { ShowInEpcotDirective } from '../../../common/epcot-config.directive';
import { DirectivesModule } from '../../../directives/directives.module';
import { NativeAlertsModule } from '../../../native-alerts/native-alerts.module';
import { StatsValueComponent } from '../../../scoreboards/components/stats-value.component';
import { ScoreboardViewmodelFactory } from '../../../scoreboards/models/scoreboard-viewmodel.factory';
import { ScoreboardHostDirective } from '../../../scoreboards/scoreboard-host.directive';
import { MyBetsLeaderboardGameScoreboardComponent } from './general/my-bets-leaderboard-game-scoreboard.component';
import { MyBetsPairGameNoScoreboardComponent } from './general/my-bets-pair-game-no-scoreboard.component';
import { MyBetsPairGameScoreboardComponent } from './general/my-bets-pair-game-scoreboard.component';
import { MyBetsPairScoreboardStatsComponent } from './general/my-bets-pair-scoreboard-stats.component';
import { MyBetsPairgameFullScoreboardStatsComponent } from './general/my-bets-pairgame-full-scoreboard-stats.component';
import { MyBetsPenaltyShootoutScoreboardStatsComponent } from './general/my-bets-penalty-shootout-scoreboard-stats.component';
import { MyBetsPenaltyShootoutScoreboardComponent } from './general/my-bets-penalty-shootout-scoreboard.component';
import { MyBetsScoreboardPairComponent } from './general/my-bets-scoreboard-pair.component';
import { MyBetsScoreboardPlayersPairComponent } from './general/my-bets-scoreboard-players-pair.component';
import { MyBetsScoreboardSetComponent } from './general/my-bets-scoreboard-set.component';
import { MyBetsSnookerScoreboardComponent } from './general/my-bets-scoreboard-snooker.component';
import { MyBetsScoreboardTimeComponent } from './general/my-bets-scoreboard-time.component';
import { MyBetsScoreboardTimerComponent } from './general/my-bets-scoreboard-timer.component';
import { MyBetsSetScoreboardStatsComponent } from './general/my-bets-set-scoreboard-stats.component';
import { MyBetsTournamentGameScoreboardComponent } from './general/my-bets-tournament-game-scoreboard.component';
import { MyBetsScoreboardResolveService } from './my-bets-scoreboard-resolve.service';
import { MyBetsBaseballScoreboardComponent } from './sport-specific/baseball/my-bets-baseball-scoreboard.component';
import { MyBetsScoreboardDartsComponent } from './sport-specific/darts/my-bets-darts-scoreboard.component';
import { MyBetsDartsStatsScoreboardComponent } from './sport-specific/darts/my-bets-darts-stats-scoreboard.component';
import { MyBetsScoreboardPeriodGameComponent } from './sport-specific/period-game/my-bets-scoreboard-period-game.component';
import { MyBetsSnookerScoreboardStatsComponent } from './sport-specific/snooker/my-bets-snooker-scoreboard-stats.component';
import { MyBetsScoreboardSoccerGoalComponent } from './sport-specific/soccer/my-bets-scoreboard-soccer-goal.component';
import { MyBetsScoreboardSoccerRedCardComponent } from './sport-specific/soccer/my-bets-scoreboard-soccer-redcard.component';
import { MyBetsScoreboardSoccerComponent } from './sport-specific/soccer/my-bets-scoreboard-soccer.component';
import { MyBetsScoreboardTennisComponent } from './sport-specific/tennis/my-bets-scoreboard-tennis.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        ScoreboardHostDirective,
        StatsValueComponent,
        NativeAlertsModule,
        AutomationModule,
        ShowInEpcotDirective,
        IconCustomComponent,
    ],
    declarations: [
        MyBetsScoreboardPlayersPairComponent,
        MyBetsPairgameFullScoreboardStatsComponent,
        MyBetsPairGameScoreboardComponent,
        MyBetsPairGameNoScoreboardComponent,
        MyBetsTournamentGameScoreboardComponent,
        MyBetsScoreboardPairComponent,
        MyBetsScoreboardSetComponent,
        MyBetsScoreboardSoccerComponent,
        MyBetsScoreboardSoccerRedCardComponent,
        MyBetsScoreboardSoccerGoalComponent,
        MyBetsPairScoreboardStatsComponent,
        MyBetsSetScoreboardStatsComponent,
        MyBetsScoreboardDartsComponent,
        MyBetsDartsStatsScoreboardComponent,
        MyBetsSnookerScoreboardComponent,
        MyBetsSnookerScoreboardStatsComponent,
        MyBetsScoreboardTennisComponent,
        MyBetsScoreboardPeriodGameComponent,
        MyBetsScoreboardTimerComponent,
        MyBetsScoreboardTimeComponent,
        MyBetsPenaltyShootoutScoreboardComponent,
        MyBetsPenaltyShootoutScoreboardStatsComponent,
        MyBetsLeaderboardGameScoreboardComponent,
        MyBetsBaseballScoreboardComponent,
    ],
    providers: [MyBetsScoreboardResolveService, ScoreboardViewmodelFactory],
    exports: [MyBetsScoreboardTimeComponent],
})
export class MyBetsScoreboardModule {}
